import { RSError, RSErrorOptions } from "./RSError";

/**
 * Erreurs liées au panier (CartModel, CartProductModel) :
 * paiement, ReCaptcha, produits indisponibles…
 */
export class RSCartError<C = Record<string, unknown>> extends RSError<C> {
  constructor(message: string, context?: C, options?: RSErrorOptions) {
    super(message, context, options);
    this.name = "RSCartError";
    Object.setPrototypeOf(this, RSCartError.prototype);
  }
}
